






































































import {Component, Prop, Vue} from "vue-property-decorator";
import ThemesStore from "@/store/modules/ThemesStore";
import SettingOptionUI from "@/components/UI/SettingOptionUI.vue";
import ThemeItemVariablesStore from "@/store/modules/ThemeItemVariablesStore";
import {Util} from "@/_global/utils";
import ThemeVariableStore from '@/store/modules/ThemeVariableStore'
import AddBadgeDialog from "@/components/Dialog/AddBadgeDialog.vue";
import ImagesStore from "@/store/modules/ImagesStore";
import SelectBadgeDialog from "@/components/Dialog/SelectBadgeDialog.vue";
import DeleteBadgeDialog from "@/components/Dialog/DeleteBadgeDialog.vue";

@Component({
    components: {
        SettingOptionUI,
        AddBadgeDialog,
        SelectBadgeDialog,
        DeleteBadgeDialog,
    },
})
export default class ThemeItem extends Vue {
    @Prop() private itemId!: number;
    private isAddingBadge: boolean = false;
    private deletingImageId: number = -1;
    private selectOptionName: string = "";

    get deb() {
        return ThemeItemVariablesStore.variableByItemId[this.itemId]
    }

    get settingOptions(): CMS.SettingOption[] {
        return ThemesStore.selectedTheme.theme_item_options || []
    }

    get languages(): CMS.Language[] {
        if (!ThemeVariableStore.all.value)
            return [];

        return ThemeVariableStore.all.value.languages;
    }

    private getName(name: string, languageCode: string): string {
        return name + "_" + languageCode;
    }

    private getOption(option: CMS.SettingOption, languageCode: string): CMS.SettingOption {
        let edited: CMS.SettingOption = Util.deepCopy(option);
        edited.name = this.getName(option.name, languageCode);
        return edited;
    }

    // CMSで編集済みの値を返却
    private getEditedOptionValue(optionName: string): any {
        const itemValue: CMS.ThemeItemVariable = ThemeItemVariablesStore.variableByItemId[this.itemId];
        if ((!itemValue) || (!itemValue.value))
            return null;

        return itemValue.value[optionName];
    }

    private onChange(option: string, value: string) {
        const themeItemVariable = ThemeItemVariablesStore.variableByItemId[this.itemId];
        if (themeItemVariable) {
            let edited: CMS.ThemeItemVariable = Util.deepCopy(themeItemVariable);
            edited.value[option] = value;
            ThemeItemVariablesStore.localEdit(edited);
        } else {
            const newVariable: CMS.ThemeItemVariable = {
                theme_id: ThemesStore.selectedTheme.id,
                item_id: this.itemId,
                value: {[option]: value}
            }
            ThemeItemVariablesStore.localAdd(newVariable);
        }
    }

    // 追加
    private onClickAddBadge(): void {
        this.isAddingBadge = true;
    }

    private onCancelAddBadge(): void {
        this.isAddingBadge = false;
    }

    private async onOkAddBadge(badge: CMS.Image) {
        // バッジを登録
        await ImagesStore.create(badge);
        this.isAddingBadge = false;
    }

    // 選択
    private onClickSelectBadge(optionName: string): void {
        this.selectOptionName = optionName;
    }

    private onCancelSelectBadge(): void {
        this.selectOptionName = "";
    }

    private async onOkSelectBadge(items: { [language_code: string]: string }) {
        this.languages.forEach(language => {
            const themeItemVariable = ThemeItemVariablesStore.variableByItemId[this.itemId];
            const index = this.getName(this.selectOptionName, language.code);
            if (themeItemVariable) {
                let edited: CMS.ThemeItemVariable = Util.deepCopy(themeItemVariable);
                edited.value[index] = items[language.code];
                ThemeItemVariablesStore.localEdit(edited);
            } else {
                const newVariable: CMS.ThemeItemVariable = {
                    theme_id: ThemesStore.selectedTheme.id,
                    item_id: this.itemId,
                    value: {[index]: items[language.code]}
                }
                ThemeItemVariablesStore.localAdd(newVariable);
            }
        });

        this.selectOptionName = "";
    }
    // 削除
    private onSelectDelete(imageId: number): void {
        this.deletingImageId = imageId;
    }

    private onCancelDeleteBadge(): void {
        this.deletingImageId = -1;
    }

    private onOkDeleteBadge(): void {
        ImagesStore.delete(this.deletingImageId);
        this.deletingImageId = -1;
    }

}
